module.exports = __webpack_public_path__ + "static/media/Sales icon@2x.349c0b91.png";